export const UPDATE_UPPER_SECTION_FIELDS = "UPDATE_UPPER_SECTION_FIELDS";
export const UPDATE_LOWER_SECTION_FIELDS = "UPDATE_LOWER_SECTION_FIELDS";
export const UPDATE_LOCATION_SECTION_FIELDS = "UPDATE_LOCATION_SECTION_FIELDS";
export const UPDATE_AVAILABLE_QTY = "UPDATE_AVAILABLE_QTY";
export const RESET_AVAILABLE_QTY = "RESET_AVAILABLE_QTY";
export const SHOW_REQUEST_CONFIRMATION_MODAL = "SHOW_REQUEST_CONFIRMATION_MODAL";
export const HIDE_REQUEST_CONFIRMATION_MODAL = "HIDE_REQUEST_CONFIRMATION_MODAL";
export const TOGGLE_CREATE_REQUEST_BUTTON_CLICK = "TOGGLE_CREATE_REQUEST_BUTTON_CLICK";
export const UPDATE_BASIC_DETAILS_LOWER_SECTION_VALIDATION_CHECK = "UPDATE_BASIC_DETAILS_LOWER_SECTION_VALIDATION_CHECK";